import { useCallback, useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { X } from "lucide-react";
import { useEscape, useLockBodyScroll } from "../lib/hooks";
import { useI18n } from "../i18n";

export default function Modal({ title, onClose, children, size = "md", labelledBy }) {
  const { t } = useI18n();
  const dialogRef = useRef(null);
  const close = useCallback(() => onClose(), [onClose]);
  useEscape(close);
  useLockBodyScroll(true);

  useEffect(() => {
    const previous = document.activeElement;
    const focusable = dialogRef.current?.querySelector(
      "input, select, textarea, button:not(.modal-close)"
    );
    (focusable || dialogRef.current)?.focus();
    return () => previous?.focus?.();
  }, []);

  const headingId = labelledBy || "modal-title";

  return createPortal(
    <div className="modal-backdrop" onMouseDown={(e) => e.target === e.currentTarget && close()}>
      <div
        className={`modal modal--${size}`}
        role="dialog"
        aria-modal="true"
        aria-labelledby={headingId}
        ref={dialogRef}
        tabIndex={-1}
      >
        <div className="modal-header">
          <h2 id={headingId}>{title}</h2>
          <button type="button" className="modal-close" onClick={close} aria-label={t("common.close")}>
            <X size={22} />
          </button>
        </div>
        <div className="modal-body">{children}</div>
      </div>
    </div>,
    document.body
  );
}
